// NPM Imports
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import Description from '../../ui-helper-elements/Description'
// JS Imports
//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

interface HoverMRRDescriptionProps {
   children?: React.ReactNode
   listMRRTotal?: number
   previousMRRTotal?: number
   MRRTotal?: number // Current currency
   MRRTotalUSD?: number // USD currency
   currencyObjectCurrent: any // Current currency
   currencyObjectUSD: any // USD currency
   placement?: string
}

export default function HoverMRRDescription({
   children,
   listMRRTotal = 0,
   previousMRRTotal = 0,
   MRRTotal = 0,
   MRRTotalUSD = 0,
   currencyObjectCurrent,
   currencyObjectUSD,
   placement = 'bottom',
}: HoverMRRDescriptionProps) {
   const state = useQuoteContext()
   const { getString } = state

   const content = (
      <div style={{ width: '450px', padding: '0.5rem', margin: '0 auto' }}>
         {/* MRR Row Title */}
         <div className='row mb-2'>
            <div
               className='col-4'
               style={{ textAlign: 'left', whiteSpace: 'nowrap' }}
            >
               <strong></strong>
            </div>
            <div
               className='col-2'
               style={{ textAlign: 'right', whiteSpace: 'nowrap' }}
            >
               <strong>{getString('global.Final')}</strong>
            </div>
            <div
               className='col-3'
               style={{ textAlign: 'right', whiteSpace: 'nowrap' }}
            >
               <strong>{getString('global.Previous')}</strong>
            </div>
            <div
               className='col-3'
               style={{
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  paddingRight: '15px',
               }}
            >
               <strong>{getString('global.DifferenceUpsell')}</strong>
            </div>
         </div>
         {/* MRR row */}
         <div className='row mb-2'>
            <div
               className='col-4'
               style={{ textAlign: 'left', whiteSpace: 'nowrap' }}
            >
               {getString('global.CommissionableMRR')}
            </div>
            <div
               className='col-2'
               style={{ textAlign: 'right', whiteSpace: 'nowrap' }}
            >
               {formatFloatAsCurrencySymbol(
                  listMRRTotal || 0,
                  currencyObjectCurrent,
                  true,
               )}
            </div>
            <div
               className='col-3'
               style={{ textAlign: 'right', whiteSpace: 'nowrap' }}
            >
               {formatFloatAsCurrencySymbol(
                  previousMRRTotal || 0,
                  currencyObjectCurrent,
                  true,
               )}
            </div>
            <div
               className='col-3'
               style={{ textAlign: 'right', whiteSpace: 'nowrap' }}
            >
               {formatFloatAsCurrencySymbol(
                  MRRTotal || 0,
                  currencyObjectCurrent,
                  true,
               )}
               {currencyObjectCurrent.Code !== 'USD' &&
                  ' (' +
                     formatFloatAsCurrencySymbol(
                        MRRTotalUSD || 0,
                        currencyObjectUSD,
                        true,
                     ) +
                     ')'}
            </div>
         </div>
         <div className='col' style={{ textAlign: 'left', whiteSpace: 'wrap' }}>
            {getString('global.HeadcountIncreaseMRRNote')}
         </div>
      </div>
   )

   return (
      <Description
         title=''
         className='col'
         content={content}
         placement={placement}
      >
         {children}
      </Description>
   )
}
